import React from 'react';

export default function Brand({ light = false }) {
  return (
    <a href="/" className={`flex items-baseline gap-1 select-none ${light ? 'text-snow' : 'text-ink'}`}>
      <span className="font-display text-[1.65rem] leading-none tracking-[-0.04em] font-bold">
        Fit<span className="text-volt">AI</span>
      </span>
      <span className={`font-display text-[1.65rem] leading-none tracking-[-0.02em] font-bold ${light ? 'text-snow/80' : 'text-ink/55'}`}>
        365
      </span>
    </a>
  );
}
